<template>
    <div :class="['cz__option', { 'cz__option-full-width': option.custom['widget-type'] === 'dynamic-image' || option.custom['widget-type'] === 'personalization' }]">
        <option-button v-if="option.custom['widget-type'] === 'button'"
            :controller="controller"
            :blueprint="blueprint"
            :option="option"
            :components="components"
            :selected="selected"
            @select="optionSelected"
            @personalization="personalize"
            @dynamicimage="setDynamicImage"
        ></option-button>

        <option-swatch v-if="option.custom['widget-type'] === 'color-swatch'"
            :controller="controller"
            :blueprint="blueprint"
            :option="option"
            :components="components"
            :selected="selected"
            @select="optionSelected"
            @personalization="personalize"
            @dynamicimage="setDynamicImage"
        ></option-swatch>

        <option-personalization v-if="option.custom['widget-type'] === 'personalization'"
            :controller="controller"
            :blueprint="blueprint"
            :option="option"
            :components="components"
            :selected="selected"
            @personalization="personalize"
            @dynamicimage="setDynamicImage"
        ></option-personalization>

        <option-upload v-if="option.custom['widget-type'] === 'dynamic-image'"
            :controller="controller"
            :blueprint="blueprint"
            :option="option"
            :components="components"
            :selected="selected"
            @personalization="personalize"
            @dynamicimage="setDynamicImage"
        ></option-upload>
    </div>
</template>

<style lang="less">
    .cz__option {
        display: inline-block;

        margin-left: 5px;
        margin-right: 5px;

        margin-bottom: 15px;
    }

    .cz__option-full-width {
        display: block;
    }

    .cz__options {
        margin-left: -5px;
        margin-right: -5px;
    }
</style>

<script>
    import OptionButton from './OptionButton';
    import OptionSwatch from './OptionSwatch';
    import OptionPersonalization from './OptionPersonalization';
    import OptionUpload from './OptionUpload';

    export default {
        props: {
            controller: Object,
            blueprint: Object,
            option: Object,
            selected: Boolean,
            components: Array,
        },
        components: {
            OptionButton,
            OptionSwatch,
            OptionPersonalization,
            OptionUpload,
        },
        methods: {
            optionSelected(option) {
                this.$emit('select', option);
            },

            personalize(text) {
                this.$emit('personalization', text);
            },

            setDynamicImage(options) {
                this.$emit('dynamicimage', options);
            },
        },
    };
</script>